var _rect, _circle, _circle2, _path, _path2, _path3, _rect2, _rect3, _path4, _path5, _circle3, _circle4, _ellipse, _ellipse2, _ellipse3, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _circle11, _path13, _path14, _path15, _path16, _circle12, _defs, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayerPortrait28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#c0983a"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 52,
    fill: "#c7a451",
    opacity: 0.55
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 17,
    r: 9,
    fill: "#5a3524"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 124C12 98 34 90 60 90S108 98 108 124Z",
    fill: "#8f8a5a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 88L60 104L70 88L66 85L60 92L54 85Z",
    fill: "#726e48"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60 104L60 124",
    stroke: "#726e48",
    strokeWidth: 1.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 106,
    width: 14,
    height: 12,
    rx: 2,
    fill: "#726e48",
    opacity: 0.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 108,
    width: 10,
    height: 2.4,
    fill: "#e3b94a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 112H28M92 112H108",
    stroke: "#726e48",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52 70H68V92C66 96 54 96 52 92Z",
    fill: "#c1906b"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 56,
    r: 5,
    fill: "#dca47a"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 56,
    r: 5,
    fill: "#dca47a"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60,
    cy: 52,
    rx: 21,
    ry: 25,
    fill: "#dca47a"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45,
    cy: 63,
    rx: 4,
    ry: 2.4,
    fill: "#e8806a",
    opacity: 0.3
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 75,
    cy: 63,
    rx: 4,
    ry: 2.4,
    fill: "#e8806a",
    opacity: 0.3
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 61,
    r: 0.9,
    fill: "#8f6a4f"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 62.5,
    r: 0.9,
    fill: "#8f6a4f"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 63.5,
    r: 0.9,
    fill: "#8f6a4f"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 73,
    cy: 61,
    r: 0.9,
    fill: "#8f6a4f"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 62.5,
    r: 0.9,
    fill: "#8f6a4f"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 63.5,
    r: 0.9,
    fill: "#8f6a4f"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 57Q56.5 62 59 63.5Q60 64 61.5 63.5",
    stroke: "#ab7f5f",
    strokeWidth: 1.8,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47 55Q51 50 55 55",
    stroke: "#2a1d1a",
    strokeWidth: 2.4,
    fill: "none",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65 55Q69 50 73 55",
    stroke: "#2a1d1a",
    strokeWidth: 2.4,
    fill: "none",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46 47L56 47",
    stroke: "#5a3524",
    strokeWidth: 2.2,
    fill: "none",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M64 47L74 47",
    stroke: "#5a3524",
    strokeWidth: 2.2,
    fill: "none",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51 67Q60 78 69 67Z",
    fill: "#fff",
    stroke: "#2a1d1a",
    strokeWidth: 1.8,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M38 50C35 29 48 22 60 22S85 29 82 50C78 41 71 35 60 35S42 41 38 50Z",
    fill: "#5a3524"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 17,
    r: 9,
    fill: "#5a3524"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35 46C33 24 47 16 60 16S87 24 85 46C79 36 71 31 60 31S41 36 35 46Z",
    fill: "#4f7a78"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M46 20L52 27M60 17L60 26M74 20L68 27M40 30L47 33M80 30L73 33",
    stroke: "#3d5f5d",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    opacity: 0.55
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M84 34L96 28L94 40Z",
    fill: "#4f7a78"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M84 34L94 46L90 36Z",
    fill: "#3d5f5d"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 35,
    r: 3,
    fill: "#3d5f5d"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "v",
    cx: "50%",
    cy: "48%",
    r: "72%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#2a1a08",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2a1a08",
    stopOpacity: 0.38
  })))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#8a6a3a",
    opacity: 0.12
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "url(#v)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerPortrait28);
export default __webpack_public_path__ + "static/media/player-portrait-28.647e7a544f15643ebf66b9dd6303dff2.svg";
export { ForwardRef as ReactComponent };